/**
 * Javascript file for the news page.
 * @author Adrian Rebmann, Andreas Emrich, Yannik Sprengart
 */

import { required, sameAs, email, minLength } from "vuelidate/lib/validators";
import auth from "../../../auth";
export default {
  name: "News",

  /**
   * The vue instance's data object.
   * @property {string} msg - The platform's name.
   * @property {*} newsstatic - Static news to be shown. 
   * @property {*} news - Dynamic news to be shown. 
   * @property {boolean} loggedIn - Status of the user's login.
   * @property {boolean} sending -Information is currently being processed.
   * @property {boolean} error - There has been an error.
   * @property {object} form.firstName - The user'S first name.
   * @property {object} form.lastName - The user's last name.
   * @property {object} form.gender - The user's gender.
   * @property {string} form.email - The user's email.
   * @property {boolean} newsletter - User subscribed to the newsletter.
   * @property {boolean} saved - Changes were saved.
   */
  data() {
    return {
      msg: "WERNER",
      newsstatic: {
        dfkismall: "/static/dfkismall.png",
        ita: "/static/ita.png",
        sf: "/static/sf.png",
        tuk: "/static/tuk.png",
        md: "/static/md.jpg",
        bmwi: "/static/bmwi.png",
        sabine: {
          image: "/static/sabine.png",
          contact:
            "<p><strong>Sabine Klein</strong> <br/>Schwerpunkt Geschäftsmodelle <br/>T    0631-20575-5029 <br/>M  <a href='mailto:sabine.klein@komz-kl.de'>sabine.klein@komz-kl.de</a></p>"
        },
        sarah: {
          image: "/static/sarah.jpg",
          contact:
            "<p><strong>Sarah Rübel</strong> <br/>Schwerpunkt Geschäftsmodelle <br/>T    0631-20575-5029 <br/>M  <a href='mailto:sarah.ruebel@komz-kl.de'>sarah.ruebel@komz-kl.de</a></p>"
        },
        andi: {
          image: "/static/andi.png",
          contact:
            "<p><strong>Andreas Emrich</strong> <br/>Schwerpunkt Geschäftsmodelle <br/>T    0631-20575-5029 <br/>M  <a href='mailto:andreas.emrich@komz-kl.de'>andreas.emrich@komz-kl.de</a></p>"
        }

      },
      news: [
        {
          hash: "10/2020",
          greeting: {
            header: "HALLO,",
            body:
              "eine neue Hauptfunktion von WERNER ist das Themenportal Technologien. Mit unserer zweiten Herausgabe in diesem Jahr möchten wir unseren Nutzern daher eine inhaltliche Erweiterung vorstellen.  Das Themenportal ergänzt unsere bereits vorhandene Technologieseite um weitere Technologien, die in neue Kategorien unterteilt sind, sodass Sie diese noch einfacher finden und suchen können. Insbesondere die Kategorie „Assistenzsysteme“ ist mit weiterführenden Informationen ausgestattet, die Ihnen diese Technologien noch detaillierter erklären."
          },
          content: [
            {
              header: "Themenportal Assistenzsysteme",
              image: "/static/news_202010_1.png",
              body:
                "Das <strong>Themenportal Assistenzsysteme</strong> umfasst eine Vielzahl neu eingepflegter Technologien rund um das Thema Assistenzsysteme. Die hier aufgeführten Technologien sind durch sehr detaillierte Informationen beschrieben und ermöglichen Ihnen eine genaue Einordnung und Vergleichbarkeit der verschiedenen Assistenzsysteme."
            },
            {
              header: "Überarbeitete Technologieseite",
              image: "/static/news_202010_2.png",
              body:
                "In Verbindung mit dem Themenportal Assistenzsysteme haben wir gleichzeitig auch unsere komplette Technologieseite überarbeitet und neu gestaltet. Sie ist jetzt übersichtlicher und gliedert die verschiedenen Technologien in mehrere Kategorien, wie bspw. Produktionstechnologien oder Künstliche Intelligenz auf. Somit können Sie präziser nach den Inhalten suchen, die Sie brauchen und können die Technologien der Kategorien direkt miteinander vergleichen, um deren Auswirkungen auf das Geschäftsmodell auf einen Blick zu sehen."
            }
          ]
        },
        {
          hash: "4/2020",
          greeting: {
            header: "HALLO,",
            body:
              "auch in diesem Jahr arbeiten wir für Sie wieder mit Hochdruck an WERNER. WERNER steht Ihnen als digitales Angebot im Rahmen von Mittelstand-Digital jederzeit zur Verfügung. Eine neue Hauptfunktion von WERNER ist der Künstliche Intelligenz-Readiness-Check (KIRC). KIRC hilft Ihnen dabei festzustellen, wie gut Ihr Unternehmen für den Einsatz von KI vorbereitet ist. Außerdem stellen wir Ihnen unsere KI-Trainer vor. Finden Sie KI-Trainer, die Sie bei Ihrem Digitalisierungs- bzw. KI-Projekt individuell unterstützen und Ihren dabei helfen, KI-Potentiale zu entdecken und auszubauen. Neben einer neuen Veranstaltungsseite sind Ihnen mehrere Funktionen von nun an auch ohne Registrierung öffentlich zugänglich. "
          },
          content: [
            {
              header: "KI-Readiness-Check",
              image: "/static/KIRC_Landing.png",
              body:
                "Eine WERNER Neuentwicklung ist der KIReadiness-Check (KIRC). Er misst für Sie anhand eines Fragebogens die Reife Ihres Unternehmens im Thema KI. Sie erhalten außerdem personalisierte Handlungsempfehlungen, um Ihren Reifegrad zu verbessern und sich somit noch effizienter auf die Einführung von KI-Anwendungen vorzubereiten."
            },
            {
              header: "KI-Trainer",
              image: "/static/kitrainer.png",
              body:
                "In Verbindung mit den bisherigen Funktionen auf WERNER können Sie nun auch direkten Kontakt mit unseren KI-Trainern aufnehmen. Die KI-Trainer helfen Ihnen dabei bereits vorhandene Potentiale für das Thema KI zu entdecken und Sie auf den erfolgreichen Einsatz von KI-Anwendungen vorzubereiten. Jeder KI-Trainer besitzt Schwerpunkte in bestimmten Themenbereichen. So können Sie KI-Trainer kontaktieren, die Ihnen bei einem Bedarf am besten weiterhelfen können."
            },
            {
              header: "Veranstaltungen suchen",
              image: "/static/events.png",
              body:
                "Ebenfalls verbessert auf WERNER ist die Veranstaltungssuche. Sie können mit Hilfe von definierten Kriterien wie etwa Themen oder Umkreis nach für Sie passenden Veranstaltungen suchen. Wenn Sie bereits andere Funktionen auf WERNER genutzt haben, werden Ihnen außerdem Veranstaltungen empfohlen, die optimal zu Ihnen und Ihrem Unternehmen passen."
            },
            {
              header: "Öffentlicher Zugriff",
              image: "/static/New_Landing.png",
              body:
                "Viele der WERNER Funktionen stehen Ihnen nun auch schon vor dem Anmelden zur Verfügung. So sind Ihnen zum Beispiel Technologien, Referenzprojekte, Veranstaltungen, Geschäftsmodell-Aspekte und die KI-Trainersuche frei ohne Registrierung bzw. Anmeldung zugänglich. "
            }
          ]
        },
        {
          hash: "3/2020",
          greeting: {
            header: "HALLO,",
            body:
              "Möchten Sie Industrie 4.0 zum Anfassen erleben? PAUL steht für „Produktion & Automatisierung erleben“. Der modulare Demonstrator zeigt Industrie 4.0 spielerisch an der Produktion eines Würfels in Losgröße 1. Ziel ist es, einem breiten Publikum die erforderlichen Kompetenzen rund um die Produktion der Zukunft aufzuzeigen. Mit Hilfe der Benutzerschnittstelle des Demonstrators kann der Anwender in verschiedene Arbeitsrollen aus dem Industrieumfeld schlüpfen – Kunde, Werker, Produktionsleiter oder Lagerist. Entsprechend können die vier Anwendungsfälle Bestellung, Fertigung, Leitung und Wartung durchgespielt werden. Auf diese Weise wird auf die speziellen Bedürfnisse des einzelnen Nutzers eingegangen. Abgesehen von der Mobilität ist der Demonstrator PAUL auch modular und kann entsprechend jederzeit erweitert werden. Es ist keine weitere Infrastruktur als ein 230V-Stromanschluss nötig, um Industrie 4.0 mit Hilfe der Plattform erlebbar zu machen. Dadurch kann er sehr einfach und flexibel bei Unternehmen vor Ort eingesetzt werden."
          },
          content: [
            {
              header: "Das Kompetenzzentrum Kaiserslautern stellt die Konstruktions- und Aufbauunterlagen KMU sowie anderen Zentren und Bildungseinrichtungen im Rahmen der Förderung durch Mittelstand-Digital kostenfrei zur Verfügung. Bei Interesse können Sie sich gerne bei uns melden!",
              image: "/static/paul.jpg",
              body: "<p><strong>Nina Obreschkova</strong> <br/>Managerin des Infocenters<br/>T    0631-20575-2080 <br/>M  <a href='mailto:nina.obreschkova@komz-kl.de'>nina.obreschkova@komz-kl.de</a></p>"
            }
          ]
        }, {
          hash: "6/2019",
          greeting: {
            header: "HALLO,",
            body:
              "wir möchten Sie auf Neuerungen der Plattform WERNER aufmerksam machen. Werner bietet Ihnen nun die Möglichkeit, nach Veranstaltungen zu suchen. Wählen Sie die Kriterien aus, nach denen Ihnen Veranstaltungen individuell empfohlen werden. Ein Erklärvideo unterstützt nun die Geschäftsmodell-Konfiguration und Sie können die auf WERNER hinterlegten Technologien direkt zu Ihrem Profil hinzufügen. Testen Sie die neuen Funktionen von WERNER."
          },
          content: [
            {
              header: "Suche nach Veranstaltungen",
              image: "/static/events.png",
              body:
                "Die Suche beinhaltet nun auch Veranstaltungen von Mittelstand-Digital. Informieren Sie sich über die Verschiedenen Angebote und suchen Sie Veranstaltungen aus, die Sie interessieren und zu Ihrem Profil passen. Über die integrierte Detailsuche können Sie die Suchergebnisse zusätzlich präzisieren und auf sich zuschneiden. Durch die hinterlegten Informationen aus Ihrem Unternehmensprofil erhalten Sie außerdem individuelle Empfehlungen. Hier können Sie auswählen, welche Informationen für die Empfehlungen berücksichtigt werden sollen. Neben ergänzenden Informationen gelangen Sie über einen Link zur Seite auf der Sie sich verbindlich zu der jeweiligen Veranstaltung anmelden können."
            },
            {
              header: "Erklärvideo",
              image: "/static/video.png",
              body:
                "Ergänzend zum Geschäftsmodell-Konfigurator steht Ihnen nun auch ein passendes Erklärvideo für diese Funktion zur Verfügung. Hier wird die grundlegende Bedienung des Konfigurators erklärt. Das Video unterstützt Sie bei Bedarf, führt Sie durch alle Funktionen des Konfigurators und gibt Ihnen einen Einblick in das volle Potential des WERNER Geschäftsmodell-Konfigurators.",
              link: true
            },
            {
              header: "Technologie hinzufügen",
              image: "/static/addtech.png",
              body:
                "Durch einen neuen Button in der Detailansicht der Technologien können Sie nun einzelne Technologien direkt in ihr Unternehmensprofil übernehmen. Hierbei können Sie auch entscheiden, ob Sie diese Technologie anbieten oder suchen. Die ausgewählten Technologien erscheinen dann sofort in Ihrem Unternehmensprofil."
            },
            {
              header: "Top-Technologie",
              image: "/static/erp.jpg",
              body:
                "Innerhalb der letzten Monate interessierten sich Nutzer von WERNER insbesondere für Enterprise Resource Planning. Das ERP-System verwaltet alle Informationen über die Ressourcen eines Unternehmens. Es unterstützt ein Unternehmen durch die Integration verschiedenster Funktionen, Aufgaben und Daten in einem einzigen Informationssystem, das von allen Mitarbeitern des Unternehmens produktiv genutzt werden kann."
            }
          ]
        },
        {
          hash: "11/2018",
          greeting: {
            header: "HALLO,",
            body:
              "wir möchten Sie auf Neuerungen der Plattform WERNER aufmerksam machen. WERNER ist nun schneller, sicherer und mobil verfügbar. Wir haben das Design grundlegend modernisiert - klare und aufgeräumte Strukturen sorgen jetzt für mehr Übersichtlichkeit und eine bessere Orientierung. Testen Sie die neuen Funktionen von WERNER."
          },
          content: [
            {
              header: "Aktuelles von WERNER",
              image: "/static/newcanvas.png",
              body:
                "Das Design von WERNER wurde in den letzten Monaten grundlegend überarbeitet. Eine Neuentwicklung ist unser Konfigurator für Geschäftsmodelle. Sie werden mit Hilfe einfacher Fragen durch die Erstellung Ihres Geschäftsmodells geleitet. Hierzu benötigen Sie kein zusätzliches Vorwissen. Sie haben außerdem jederzeit die Möglichkeit, eigene Ideen hinzuzufügen oder das Geschäftsmodell unabhängig von den Fragen anzulegen."
            },
            {
              header: "Neue Funktionen",
              image: "/static/newfunctions.png",
              body:
                "Nach der Erstellung Ihres Geschäftsmodells können Sie in WERNER auch Empfehlungen für Technologien erhalten. Diese werden individuell für die Einträge in Ihrem Modell generiert. Sie können in den vorgeschlagenen Technologien stöbern oder sich von den Referenzprojekten inspirieren lassen, die eine bestimmte Technologie bereits nutzen."
            },
            {
              header: "Top-Technologie",
              image: "/static/toptech.png",
              body:
                "Innerhalb der letzten Monaten interessierten sich Nutzer von WERNER insbesondere für die Technologie 3D-Druck. Das 3D-Druckverfahren trägt Material Schicht für Schicht auf, um so dreidimensionale Gegenstände zu erzeugen. 3D-Drucker werden in der Industrie und der Forschung eingesetzt. Daneben gibt es Anwendungen im Heim- und Unterhaltungsbereich sowie in der Kunst. "
            }
          ]
        }
      ],
      loggedIn: auth.loggedIn(),
      sending: false,
      error: false,
      form: {
        firstname: null,
        lastname: null,
        gender: null,
        email: "",
      },
      newsletter: false,
      saved: false
    };
  },

  /**
   * Validation to be done to the data.
   * @property {*} form.firstName - Validation to be done to the entered first name.
   * @property {*} form.lastName - Validation to be done to the entered last name.
   * @property {*} form.gender - Validation to be done to the entered gender.
   * @property {*} form.email - Validation to be done to the entered email.
   */
  validations: {
    form: {
      firstname: {
        required,
        minLength: minLength(3)
      },
      lastname: {
        required,
        minLength: minLength(3)
      },
      gender: {
        required
      },
      email: {
        required,
        email
      }
    }
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Returns to the previously visited page.
     */
    goBack() {
      this.$router.go(-1);
    },

    /**
     * Determines if the field is invalid or not.
     * @param {string} fieldName - The name of the field.
     */
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];
      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },

    /**
     * Validates the data. If the data is valid, it signs the user up for the newsletter.
     */
    validateData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.signupForNewsletter();
      }
    },

    /**
     * Signs the user up to the newsletter.
     */
    signupForNewsletter() {
      this.sending = true;
      auth
        .registerForNewsletter(
          this.form.email,
          this.form.firstname,
          this.form.lastname,
          this.form.gender
        )
        .then((res) => {
          if (!res.data.userExisted) {
            this.sending = false;
            this.saved = true;
            this.newsletter = false;
          } else {
            this.clearMail();
            this.error = true;
            this.sending = false;
            window.setTimeout(() => {
              this.error = false;
            }, 3000);
          }
        })
        .catch(err => {
          //console.log(err);
          this.sending = false;
          this.error = true;
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/landing/news/news.js